<template>
  <div v-loading="loading" class="page-form">
    <h3 class="title">地址变更申请</h3>

    <div class="form-container">
      <errors-list :errors="errorsList" />
      <div class="tools">
        <form-button style="margin-right: 10px" @click="$router.go(-1)">返回</form-button>
        <btky-header
          :form-data="condition"
          :process-key="processKey"
          @formDataSave="validate(saveData)"
          @validate="validate"
          @startflow="startflow"
          @advanceSuccess="advanceSuccess"
        />
      </div>
      <el-form ref="form" :show-message="false" inline size="mini" label-width="100px" :model="condition" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="申请单号">
              <el-input
                v-model="condition.billCode"
                placeholder="自动生成"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请单位">
              <el-input
                v-model="wlyClientPo.name_org1"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请日期">
              <el-input v-model="condition.createdDate" placeholder="请输入" type="text" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="变更原因" class="reason" prop="cause">
              <el-input
                v-model="condition.cause"
                placeholder="请输入"
                type="textarea"
                clearable
                :autosize="{ minRows: 2, maxRows: 2 }"
                resize="none"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="地址信息" :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <table-button name="add" tip="增加" @click="insertAddressList" />
          <table-button name="delete" tip="删除" @click="removeAddressList" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions3.columns"
          :data="gridOptions3.data"
          :edit-rules="validRules"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions3.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-select
                v-if="item.field === 'ADR_KIND'"
                v-model="row[item.field]"
                size="mini"
                @change="addressTypeChange($event, row)"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0099']"
                  :key="selectItem.value"
                  :label="selectItem.name"
                  :value="selectItem.value"
                />
              </el-select>
              <el-select
                v-else-if="item.field === 'REGION'"
                v-model="row[item.field]"
                size="mini"
                @change="changeRegion($event, row)"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['province']"
                  :key="selectItem.BLAND"
                  :label="selectItem.BEZEI"
                  :value="selectItem.BLAND"
                />
              </el-select>

              <el-select
                v-else-if="item.field === 'CITY_CODE'"
                v-model="row[item.field]"
                size="mini"
                @change="changeCity($event, row)"
              >
                <el-option
                  v-for="selectItem in row['cityOptions']"
                  :key="selectItem.CITY_CODE"
                  :label="selectItem.CITY_NAME"
                  :value="selectItem.CITY_CODE"
                />
              </el-select>

              <el-select
                v-else-if="item.field === 'STREETCODE'"
                v-model="row[item.field]"
                size="mini"
              >
                <el-option
                  v-for="selectItem in row['streetOptions']"
                  :key="selectItem.STRT_CODE"
                  :label="selectItem.MC_STREET"
                  :value="selectItem.STRT_CODE"
                />
              </el-select>

              <el-input
                v-else-if="gridOptions3.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                placeholder="请输入"
                size="mini"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <btky-footer :form-data="condition" />
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getArea, apiGetOrgOrBase } from '@/api/sap/common-sap'
import { getClientDetail } from '@/api/sap/client-sap'
import { handlerFlow } from '@/api/flowHander'

import { apiSapSingleClientInfo } from '@/api/common'
import {
  getUpdateData
} from '@/api/client'
export default {
  props: {
    clientData: {
      type: Object,
      defualt: () => null
    }
  },
  data() {
    const rules = {
      cause: [{ required: true, message: '请输入变更原因', trigger: 'blur' }]
    }
    return {
      validRules: {
        ADR_KIND: [{ required: true }],
        C_O_NAME: [{ required: true }],
        TEL_NUMBER: [{ required: true }],
        REGION: [{ required: true }],
        CITY_CODE: [{ required: true }],
        STREETCODE: [{ required: true }],
        STREET: [{ required: true }]
      },
      rules,
      errorsList: [],
      processKey: 'addressChange',
      PARTNER: '',
      wlyClientPo: {},
      condition: {
        id: '',
        status: 0,
        billCode: '',
        createdDate: '',
        createdByName: '',
        customerCode: '',
        cause: '',
        partner: '',
        dlete: '',
        crmAddApprovalDtl: []
      },
      loading: '',
      TAX: {},
      HISTORY: [],
      catchAreaList: [],
      catchCityList: [],
      isChangeCustome: 0,
      employeeControl: '',
      catchBase: {},
      gridOptions3: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ADR_KIND', title: '地址类型', width: 180, slots: { default: 'ADR_KIND' }, editRender: {}},
          { field: 'C_O_NAME', title: '联系人', width: 180, slots: { default: 'C_O_NAME' }, editRender: {}},
          { field: 'BUILDING', title: '身份证号', width: 180, slots: { default: 'BUILDING' }},
          { field: 'TELNR_LONG', title: '电话', width: 180, slots: { default: 'TELNR_LONG' }},
          { field: 'TEL_NUMBER', title: '手机', width: 180, slots: { default: 'TEL_NUMBER' }, editRender: {}},
          { field: 'FAX_NUMBER', title: '传真', width: 180, slots: { default: 'FAX_NUMBER' }},
          { field: 'REGION', title: '省', width: 180, slots: { default: 'REGION' }, editRender: {}},
          { field: 'CITY_CODE', title: '市', width: 180, slots: { default: 'CITY_CODE' }, editRender: {}},
          { field: 'STREETCODE', title: '区', width: 180, slots: { default: 'STREETCODE' }, editRender: {}},
          { field: 'STREET', title: '地址', width: 180, slots: { default: 'STREET' }, editRender: {}}
        ],
        columnsFieldTypes: {
          ADR_KIND: 'select',
          C_O_NAME: 'input',
          BUILDING: 'input',
          TELNR_LONG: 'input',
          TEL_NUMBER: 'input',
          FAX_NUMBER: 'input',
          REGION: 'select',
          CITY_CODE: 'select',
          STREETCODE: 'select',
          STREET: 'input'
        },
        data: [],
        delData: []
      },
      ProductXID: '',
      addressRow: null,
      selectDataOptions: {
        province: [],
        orgList: []
      }
    }
  },
  watch: {
    'gridOptions3.data': {
      handler(val) {
        this.condition.crmAddApprovalDtl = val
        console.log(val)
      },
      deep: true
    },
    'wlyClientPo.name_org1': {
      handler(val) {
        this.condition.createdByName = val
      },
      deep: true
    }
  },
  created() {
    this.condition.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    this.init()
  },
  methods: {
    startflow(data) {
      // this.id = data.bizId
      Object.assign(this.condition, data.bizData)
      this.condition.id = data.id
      this.condition.cause = data.cause
      this.condition.billCode = data.billCode
      this.condition.billStatus = data.bizData.billStatus
      this.condition.createdByName = this.wlyClientPo.name_org1
    },
    validate(cb) {
      this.errorsList = []
      this.$refs.form.validate((valid, err) => {
        if (valid) {
          const keys = Object.keys(this.validRules)
          // 验证表格
          try {
            this.gridOptions3.data.forEach((row, i) => {
              for (const key of keys) {
                if (!row[key]) {
                  throw new Error('请输入必输项！')
                }
              }
              const regCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
              if (!regCard.test(row.BUILDING)) {
                throw new Error(`第${i + 1}行` + '身份证格式不正确！')
              }
              const regPhone = /^1[3|4|5|7|8][0-9]{9}$/
              if (!regPhone.test(row.TEL_NUMBER)) {
                throw new Error(`第${i + 1}行` + '手机号格式不正确！')
              }
              const regTel = /^(\d{3,4}-)?[0-9]{7,8}$/
              if (!regTel.test(row.TELNR_LONG)) {
                throw new Error(`第${i + 1}行` + '电话号格式不正确！')
              }
            })
            this.condition.crmAddApprovalDtl = [...this.gridOptions3.data, ...this.gridOptions3.delData]

            cb()
          } catch (e) {
            this.errorsList.push(e.message)
          }
        } else {
          this.errorsList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    saveData() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.condition))
      handlerFlow(params, this.processKey)
        .then(async response => {
          this.loading = false
          if (!this.condition.id) {
            this.startflow(response.data)
            this.condition.billCode = response.data.bizData.billCode
          }
          if (response.status == 1) {
            this.$message.success('保存成功！')
          }
          // await advance(this.condition)
        })
        .catch(() => {
          this.loading = false
        })
    },
    advanceSuccess(id) {
      if (id) {
        this.id = id
      }
    },
    init() {
      const { id, taskId } = this.$route.query
      if (id) {
        this.condition.bizId = id
        this.condition.taskId = taskId
        this.getToAddressPo()
        this.getSelectDictDataOrigin('A0099')
        // this.getSelectDictDataOrigin('A0019')
        // this.getSelectDictDataOrigin('A0054')
        // this.getSelectDictDataOrigin('A0032')
        // this.getSelectDictDataOrigin('A0009')
        getArea('', 'region').then(res => {
          this.selectDataOptions.province = res.DATA
        })
        this.findWlyOrg()
        // this.addClientAddress();
      } else {
        this.getClientDetailInfo()
        this.getInfo()
        // await this.initAddressRow()

        // 保存接口
        //  this.getApplyForNum()

        this.getSelectDictDataOrigin('A0099')
        // this.getSelectDictDataOrigin('A0019')
        // this.getSelectDictDataOrigin('A0054')
        // this.getSelectDictDataOrigin('A0032')
        // this.getSelectDictDataOrigin('A0009')
        getArea('', 'region').then(res => {
          this.selectDataOptions.province = res.DATA
        })
        this.findWlyOrg()
        // this.addClientAddress();
      }
    },
    getToAddressPo() {
      getUpdateData({ id: this.$route.query.id }).then(response => {
        console.log(response.data)
        Object.assign(this.condition, response.data)
        this.wlyClientPo.name_org1 = response.data.createdByName
        this.gridOptions3.data = response.data.crmAddApprovalDtl
        this.initAddressRow()
      })
    },

    async getClientDetailInfo() {
      this.PARTNER = this.$store.getters.role.USER_BP
      this.condition.partner = this.PARTNER
      // const { data } = await getDataFromSap({partner: this.PARTNER})
      const { DATA } = await getClientDetail({ PARTNER: this.PARTNER })
      this.condition.customerCode = this.PARTNER
      this.gridOptions3.data = DATA.ADDRESS
      await this.initAddressRow()
    },
    // 地址类型改变
    addressTypeChange(e, row) {
      if (e === 'BILL_TO' && this.gridOptions3.data.some(v => v.ADR_KIND === 'BILL_TO')) {
        row.ADR_KIND = ''
        this.$message.error('不能改为开票地址！')
      }
    },
    async changeColums(e, row) {
      if (!e) return
      const { DATA } = await apiGetOrgOrBase(e, 2)
      this.$set(row, 'baseList', DATA)
    },
    async getInfo() {
      const params = {
        PARTNER: this.$store.getters.role.USER_BP
      }
      const res = await apiSapSingleClientInfo(params)
      this.wlyClientPo = res.data.info
    },
    async changeRegion(e, row) {
      row.CITY_CODE = ''
      row.STREETCODE = ''
      this.addressRow = row
      const { DATA } = await getArea(e, 'city')
      this.addressRow.cityOptions = DATA
      this.addressRow.streetOptions = []
    },
    async changeCity(e, row) {
      row.STREETCODE = ''
      this.addressRow = row
      const { DATA } = await getArea(e, 'street')
      this.addressRow.streetOptions = DATA
    },
    async initAddressRow() {
      for (const row of this.gridOptions3.data) {
        if (row.REGION) {
          const { DATA } = await getArea(row.REGION, 'city')
          this.$set(row, 'cityOptions', DATA)
        }
        if (row.CITY_CODE) {
          const { DATA } = await getArea(row.CITY_CODE, 'street')
          this.$set(row, 'streetOptions', DATA)
        }
      }
    },
    submitForm() {
      const result = {
        approve: this.gridOptionsApprove.data[0],
        INFO: this.wlyClientPo, // 基本信息
        ADDRESS: this.gridOptions3.data, // 地址信息
        ADDRESS_D: this.gridOptions3.delData
      }
      return result
    },
    // 获取组织机构
    async findWlyOrg() {
      const { DATA } = await apiGetOrgOrBase('', 1)
      this.selectDataOptions['orgList'] = DATA
      // this.saleCenterGridOptions.columnsFields.ZZFLD00001H.options = DATA
    },
    // 保存地址信息
    // addClientAddress() {
    //  const columns = this.gridOptions3.columns.filter(v => !v.type)
    //   const data = {}
    //   columns.forEach(v => (data[v.field] = ''))
    //   data.cityOptions = []
    //   data.streetOptions = []
    //   this.gridOptions3.data.unshift(data)
    // },

    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 新增地址信息
    insertAddressList() {
      const columns = this.gridOptions3.columns.filter(v => !v.type)
      const data = {}
      columns.forEach(v => (data[v.field] = ''))
      data.cityOptions = []
      data.streetOptions = []
      this.gridOptions3.data.unshift(data)
    },
    startflow(data) {
      this.id = data.bizId
    },
    // 删除地址信息
    async removeAddressList() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      if (checkedList.some(item => item.ADR_KIND === 'BILL_TO')) {
        return this.$message.warning('开票地址不能删除！')
      }
      // const hasGuids = checkedList.filter(v => v.gUID)
      // // 获取行项目的id 字段
      // const GUIDS = hasGuids.map(item => item.gUID)
      // const res = await deleteAddress( GUIDS )

      const hasGuids = checkedList.filter(v => v.GUID)
      // 获取行项目的id 字段
      const ids = hasGuids.map(item => {
        item.dlete = 'x'
        return item.id
      })
      // const res = await deleteAddress( ids )

      this.gridOptions3.delData = this.gridOptions3.delData.concat(hasGuids)
      checkedList.forEach(item => {
        const index = this.gridOptions3.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions3.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common-title {
  margin-top: 50px !important;
}
.page-container {
  padding: 10px;
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/addressChange.vue